import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "@common/axios";
import ShortcutLink from "@common/ShortcutLink";
import ListItemDiagnosticTestResultStudent from "@common/ListItemDiagnosticTestResultStudent";
import {UserContext} from "@context/UserContext";
import UserReviewConceptsDialog from "../review/UserReviewConceptsDialog";
import {BrandContext} from "@context/BrandContext";

const StudentDiagnosticTestResultDashboardWidget = props => {
    const {className} = props;
    const [isLoading, setLoading] = useState(true);
    const [testResults, setTestResults] = useState([]);
    const [testResultId, setTestResultId] = useState(null);
    const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);

    useEffect(() => {
        setLoading(true);
        if (user.userId !== undefined) {
            axios.get('/web/ui/test/userDiagnosticTestResults')
                .then(response => {
                    setTestResults(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, []);

    const openFeedbackDialog = (testResultId) => {
        setTestResultId(testResultId);
        setFeedbackDialogOpen(true);
    }

    const handleCloseFeedbackDialog = () => {
        setFeedbackDialogOpen(false);
        setTestResultId(null);
    }

    return (
        <DashboardWidget
            title={
                <>
                    <svg className="ch-icon-sm" viewBox="0 0 128 128">
                        <use href="#tests-icon"></use>
                    </svg>
                    {brandConfig.useStudentAssessmentReactUI ? (
                            <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/test/studentTestAssignments'} hash={brandConfig.showStudentAssessmentTabbed ? 'results' : null}>
                                <span>Diagnostic tests results</span>
                            </ShortcutLink>
                        )
                        :
                        (<ShortcutLink className="ch-highlight" shortcutUrl={brandConfig.useStudentAssessmentReactUI ? '/web/ui/view/test/studentTestAssignments' : '/controlCentre/showStudentTests.action'}>
                            <span>Diagnostic tests results</span>
                        </ShortcutLink>)}

                </>
            }
            className={className}
            isLoading={isLoading}>
            <div className={'ch-dashboard-blk-body'}>
                {testResults.length > 0 &&
                    <table style={{width: '100%'}} className={'ch-dashboard-list ch-list'}>
                        <tbody>
                        <tr>
                            <th>Test</th>
                            <th style={{width: '60%'}}>
                                Results
                            </th>
                            <th style={{width: '60px', textAlign: 'center'}}>Score</th>
                        </tr>
                        {testResults.map((testResult, index) => (
                            <ListItemDiagnosticTestResultStudent key={testResult.testResultId} testResult={testResult} callback={() => openFeedbackDialog(testResult.testResultId)} />
                        ))}
                        </tbody>
                    </table>
                }
                {testResults.length == 0 &&
                    <div className="ch-list-item-disabled">No test results</div>
                }
            </div>
            <UserReviewConceptsDialog testResultId={testResultId} open={feedbackDialogOpen} handleClose={handleCloseFeedbackDialog}/>
        </DashboardWidget>
    )
}

export default StudentDiagnosticTestResultDashboardWidget;